const testimonials = [
  {
    name: "Captain Carlos M.",
    location: "Coconut Grove, Miami, FL",
    rating: 5,
    text: "I'm a yacht captain based out of Coconut Grove and I had a charter booking to the Bahamas leaving in two days. One of my deckhands discovered his passport had expired three months prior. Fast Passport Center processed his renewal and got it back to us in under 48 hours. We made our charter departure from Key Biscayne marina with zero issues. Their team understood the urgency and moved fast.",
    service: "Passport Renewal",
  },
  {
    name: "The Rodriguez Family",
    location: "Little Havana, Miami, FL",
    rating: 5,
    text: "We booked a Carnival cruise from PortMiami for our family reunion with just under two weeks of notice. I checked our passports ten days before sailing and discovered my daughter's passport had expired eight months earlier. She's only twelve so it was only a five-year passport. Fast Passport Center processed her new passport in three days. We made our cruise embarkation with zero stress. They even helped us understand the parental consent requirements at the Miami USPS office.",
    service: "Child Passport",
  },
  {
    name: "Elena V.",
    location: "Brickell, Miami, FL",
    rating: 5,
    text: "I had an Art Basel Miami Beach meeting that extended into an emergency trip to the Basel fair in Switzerland — confirmed with six days of notice. My passport had only four months of validity left, and the Schengen Area requires three months beyond departure. Fast Passport Center processed my renewal in four days. I made my flight from MIA to Zurich and closed a major gallery partnership. Their team was responsive at every step, even on a weekend.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MiamiTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Miami Travelers Say About Our Emergency & Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Brickell, Little Havana, Coconut Grove, and Miami-Dade County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}